import { Select, SelectItem, Button, Badge, Icon } from "@conuti-das/prince-ui";
import { Flex, princeIcon } from "@/ui-prince";
import type { MapperBundle } from "@/api/mapperApi";
import type { Perspective } from "./bridgeModel";

export function MappingTopBar({
  bundles, bundleId, onBundle,
  perspective, onPerspective,
  options, selection, onSelection,
  msgTypeFilter, onClearMsgTypeFilter, msgTypes, onSetMsgTypeFilter,
  swapped, onSwap, onOpenTest, tableMode, onToggleTable,
  onReview, reviewing,
}: {
  bundles: MapperBundle[];
  bundleId: string;
  onBundle: (id: string) => void;
  perspective: Perspective;
  onPerspective: (p: Perspective) => void;
  options: string[];
  selection: string;
  onSelection: (v: string) => void;
  msgTypeFilter: string | null;
  onClearMsgTypeFilter: () => void;
  msgTypes: string[];
  onSetMsgTypeFilter: (mt: string) => void;
  swapped: boolean;
  onSwap: () => void;
  onOpenTest: () => void;
  tableMode: boolean;
  onToggleTable: () => void;
  onReview: (mode: "check" | "fill_gaps") => void;
  reviewing: boolean;
}) {
  return (
    <Flex style={{ gap: "12px", alignItems: "center", flexWrap: "wrap", padding: "8px 12px" }}>
      <label className="prn-field-label">Version</label>
      <Select
        selectedKey={bundleId}
        onSelectionChange={(k) => { if (k) onBundle(String(k)); }}
      >
        {bundles.map((b) => (
          <SelectItem key={b.id} id={b.id}>{b.yyyymm}</SelectItem>
        ))}
      </Select>

      <Button
        variant={perspective === "msgtype" ? "filled" : "plain"}
        onPress={() => onPerspective("msgtype")}
      >
        Nachrichtentyp
      </Button>
      <Button
        variant={perspective === "bo" ? "filled" : "plain"}
        onPress={() => onPerspective("bo")}
      >
        Geschäftsobjekt
      </Button>

      <Select
        selectedKey={selection || "__none__"}
        onSelectionChange={(k) => { if (k && k !== "__none__") onSelection(String(k)); }}
        style={{ minWidth: "200px" }}
      >
        {options.map((o) => (<SelectItem key={o} id={o}>{o}</SelectItem>))}
      </Select>

      {perspective === "bo" && (
        msgTypeFilter ? (
          <button
            onClick={onClearMsgTypeFilter}
            style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
          >
            <Badge tone="teal">
              Nachrichtentyp: {msgTypeFilter} ✕
            </Badge>
          </button>
        ) : (
          <Select
            selectedKey="__all__"
            onSelectionChange={(k) => { if (k && k !== "__all__") onSetMsgTypeFilter(String(k)); }}
          >
            <SelectItem id="__all__">alle Nachrichtentypen</SelectItem>
            {msgTypes.map((mt) => (<SelectItem key={mt} id={mt}>{mt}</SelectItem>))}
          </Select>
        )
      )}

      <Flex style={{ marginLeft: "auto", gap: "8px" }}>
        <Button
          variant="tinted"
          onPress={() => onReview("fill_gaps")}
          isDisabled={reviewing}
          data-testid="review-fill-btn"
        >
          {reviewing ? "KI prüft …" : "KI: ergänzen"}
        </Button>
        <Button
          variant="plain"
          onPress={() => onReview("check")}
          isDisabled={reviewing}
          data-testid="review-check-btn"
        >
          KI: prüfen
        </Button>
        <Button variant="plain" onPress={onSwap}>{swapped ? "BO4E ⇄ EDI" : "EDI ⇄ BO4E"}</Button>
        <Button variant="plain" onPress={onToggleTable}>{tableMode ? "Brücke" : "⊞ Tabelle"}</Button>
        <Button variant="plain" onPress={onOpenTest}>
          <Icon name={princeIcon("play")} size={16} />
          Testen
        </Button>
      </Flex>
    </Flex>
  );
}
